import * as React from "react";
const autobind = require("class-autobind").default;
import styled, { css } from "../../../styled/index";
import lighten from "polished/lib/color/lighten";
import { CS } from "../../../styles/index";
import { BaseInputCSS } from "../input/index";
import { FaTimes, FaChevronDown } from "react-icons/fa";
import Fuse from "fuse.js";
import { Tag, TagTimes } from "../input.tags/index";
import shortid from "shortid";
const ClickOutComponent = require("react-onclickout");
export const Wrapper = styled("div") `
  ${BaseInputCSS};
  ${(props) => props.shadow ? CS.shadow.light[props.shadow] : ""};
  position: relative;
  display: flex;
  align-items: center;
  justify-content: space-between;
  height: auto;
  border-color: ${({ focused, theme }) => focused ? theme.colors.primary : theme.input.border};
  padding: 0;
`;
export const WrapperInner = styled("div") `
  display: flex;
  flex-grow: 1;
  height: auto;
  padding: 3px;
  ${({ type }) => type === "single" ? css `
    align-items: center;
    flex-wrap: nowrap;
  ` : css `
    flex-wrap: wrap;
  `};
  > * {
    margin: 3px;
  }
`;
export const InputField = styled("input") `
  ${BaseInputCSS};
  cursor: default;
  border: none;
  width: auto;
  flex-grow: 1;
  height: 24px;
  line-height: normal;
  padding: 0 5px;
  &:focus {
    border: none !important;
  }
`;
export const InputIcon = styled("div") `
  height: 22px;
  min-width: 36px;
  width: 36px;
  display: flex;
  align-items: center;
  justify-content: center;
  border-left: 1px solid ${({ theme }) => theme.input.border};
  color: ${({ theme }) => theme.input.border};
  font-size: 12px;
`;
export const Dropdown = styled("div") `
  ${CS.shadow.light.two};
  z-index: 3;
  position: absolute;
  top: 120%;
  width: 100%;
  height: auto;
  max-height: 200px;
  overflow-y: auto;

  display: ${({ active }) => active ? "block" : "none"};

  border-radius: 3px;
  background: ${({ theme }) => theme.input.background};
  color: ${({ theme }) => theme.input.text};
  border: 1px solid ${({ theme }) => theme.input.border};
`;
export const DropdownOption = styled("div") `
  cursor: pointer;
  width: 100%;
  padding: 8px 12px;
  ${({ active }) => active ? css `
    background: ${({ theme }) => lighten(0.07, theme.colors.primary)};
    color: ${({ theme }) => theme.colors.primary_text};
  ` : ""};
  &:hover {
    background: ${({ theme }) => theme.colors.primary};
    color: ${({ theme }) => theme.colors.primary_text};
  }
`;
export class SelectAdv extends React.PureComponent {
    inputId;
    lastOpened = null;
    fuse;
    constructor(props) {
        super(props);
        autobind(this);
        this.state = {
            input: "",
            inputFocused: false,
        };
        this.fuse = new Fuse(props.options, {
            shouldSort: true,
            keys: ["value", "label"],
            threshold: 0.3,
        });
        this.inputId = props.id || shortid.generate();
    }
    componentDidUpdate(prevProps) {
        this.lastOpened = this.state.inputFocused ? Date.now() : null;
        if (prevProps.options.length !== this.props.options.length) {
            this.fuse = new Fuse(this.props.options, {
                shouldSort: true,
                keys: ["value", "label"],
                threshold: 0.3,
            });
        }
    }
    onInputChange(e) {
        if (this.state.inputFocused) {
            this.setState({ input: e.target.value });
        }
    }
    onChangeSingle(o) {
        if (this.props.type === "single") {
            this.props.onChange(o.value);
            this.toggleDropdown(false);
        }
    }
    onChangeMulti(o) {
        const props = this.props;
        if (props.value) {
            const selected = props.value ? [...props.value] : [];
            const foundIndex = selected.indexOf(o.value);
            if (foundIndex !== -1) {
                selected.splice(foundIndex, 1);
            }
            else {
                selected.push(o.value);
            }
            props.onChange(selected);
            // this.toggleDropdown(false);
        }
    }
    onClickOut() {
        if (this.lastOpened && ((Date.now() - this.lastOpened) > 100)) {
            this.toggleDropdown(false);
        }
    }
    toggleDropdown(open) {
        const el = document.getElementById(this.inputId);
        if (open) {
            this.setState({ inputFocused: true });
            if (el) {
                el.focus();
            }
        }
        else {
            this.setState({ inputFocused: false, input: "" });
            if (el) {
                el.blur();
            }
        }
    }
    renderMulti(props) {
        const value = props.value || [];
        const { shadow, placeholder, options, searchOnly } = props;
        const { input, inputFocused } = this.state;
        const finalPlaceholder = placeholder || (searchOnly ? "Type to search..." : "Select from the dropdown or type to search...");
        const selected = value
            .map((v) => options.find((o) => o.value === v))
            .filter((v) => !!v);
        const allSelected = selected.length === options.length;
        let dropdownActive = inputFocused;
        let results = searchOnly ? [] : options.filter((o) => value.indexOf(o.value) === -1);
        let searched = false;
        let inputFieldValue = "";
        if (inputFocused) {
            inputFieldValue = input;
            if (inputFieldValue) {
                results = this.fuse.search(inputFieldValue).slice(0, 25);
                searched = true;
            }
        }
        if (dropdownActive && searchOnly && !input) {
            dropdownActive = false;
        }
        else if (dropdownActive && allSelected) {
            dropdownActive = false;
        }
        return (React.createElement(Wrapper, { shadow: shadow, focused: inputFocused, onClick: () => this.toggleDropdown(!inputFocused) },
            React.createElement(WrapperInner, { type: this.props.type },
                selected.map((option, i) => (React.createElement(Tag, { key: i },
                    option.label,
                    React.createElement(TagTimes, { onClick: () => this.onChangeMulti(option) },
                        React.createElement(FaTimes, null))))),
                (!allSelected || options.length === 0) &&
                    React.createElement(InputField, { form: "doesnt-exists", placeholder: (options.length === 0 ? "No items found" :
                            selected.length > 0 ? "" :
                                finalPlaceholder), value: inputFieldValue, onChange: this.onInputChange, id: this.inputId })),
            (!allSelected || options.length === 0) &&
                React.createElement(InputIcon, null,
                    React.createElement(FaChevronDown, null)),
            React.createElement(ClickOutComponent, { onClickOut: this.onClickOut },
                React.createElement(Dropdown, { active: dropdownActive, onClick: (e) => e.stopPropagation() },
                    results.map((o, i) => (React.createElement(DropdownOption, { key: i, onClick: () => this.onChangeMulti(o), active: value.indexOf(o.value) !== -1 }, o.label))),
                    results.length === 0 && (React.createElement("div", { className: "text-center p-tb-3" }, (searchOnly && !searched) ? "Type to start searching" : "No options found"))))));
    }
    renderSingle(props) {
        const { value, shadow, placeholder, options, searchOnly } = props;
        const { input, inputFocused } = this.state;
        const finalPlaceholder = placeholder || (searchOnly ? "Type to search..." : "Select from the dropdown or type to search...");
        let dropdownActive = inputFocused;
        let results = searchOnly ? [] : options;
        let searched = false;
        let inputFieldValue = "";
        if (inputFocused) {
            inputFieldValue = input;
            if (inputFieldValue) {
                results = this.fuse.search(inputFieldValue).slice(0, 25);
                searched = true;
            }
        }
        else if (value) {
            const option = options.find((o) => o.value === value);
            if (option) {
                inputFieldValue = option.label;
            }
        }
        if (dropdownActive && searchOnly && !input) {
            dropdownActive = false;
        }
        return (React.createElement(Wrapper, { shadow: shadow, focused: inputFocused, onClick: () => this.toggleDropdown(!inputFocused) },
            React.createElement(WrapperInner, { type: this.props.type },
                React.createElement(InputField, { id: this.inputId, form: "doesnt-exists", placeholder: finalPlaceholder, value: inputFieldValue, onChange: this.onInputChange })),
            React.createElement(InputIcon, null,
                React.createElement(FaChevronDown, null)),
            React.createElement(ClickOutComponent, { onClickOut: this.onClickOut },
                React.createElement(Dropdown, { active: dropdownActive, onClick: (e) => e.stopPropagation() },
                    results.map((o, i) => (React.createElement(DropdownOption, { key: i, onClick: () => this.onChangeSingle(o), active: value === o.value }, o.label))),
                    results.length === 0 && (React.createElement("div", { className: "text-center p-tb-3" }, (searchOnly && !searched) ? "Type to start searching" : "No options found"))))));
    }
    render() {
        if (this.props.type === "multi") {
            return this.renderMulti(this.props);
        }
        return this.renderSingle(this.props);
    }
}
//# sourceMappingURL=index.js.map